<script lang="ts">
  import type { JumpingBubblesConfig } from './types';
  import { slide } from '@lib/directives';
  
  export let config: JumpingBubblesConfig;
  export let scale: number = 1;

  const bubbles = Array(4).fill(0).map((_, i) => ({
    delay: i * 0.15
  }));
</script>

<div class="bubbles-container" style:--scale={scale} use:slide={{ translate: 1, duration: 900, delay: 450, startOpacity: 0 }}>
  {#each bubbles as bubble, i}
    <div 
      class="bubble"
      style:--delay={bubble.delay}s
      style:--color={config.color || 'var(--theme-primary-color)'}
    />
  {/each}
</div>

<style>
  .bubbles-container {
    width: 100%;
    height: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    position: relative;
  }

  .bubble {
    width: 25px;
    height: 25px;
    background-color: var(--color);
    border-radius: 50%;
    opacity: 0.7;
    animation: pulse 1.1s ease-in-out infinite;
    animation-delay: var(--delay);
  }

  @keyframes pulse {
    0%, 100% {
      transform: scale(0.4);
    }
    50% {
      transform: scale(1.2);
    }
  }
</style> 